import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function CollapseablePerguntaRespostaItemComponent(props) {
  return (
    <div className="accordion text-align-justify" id={`FAQ_${props.id}`} key={`FAQ_${props.id}`}>
      <div className="accordion-item border-start-0 border-end-0 border-top-0">
        <p className="accordion-header p-0" id={`headingPergunta_${props.id}`}>
          <button
            className={`accordion-button ps-3 pe-0 bg-white border-0 collapsed border-start border-5 ${props.borderColor} rounded-0`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#resposta_${props.id}`}
            aria-expanded="false"
            aria-controls={`resposta_${props.id}`}
            style={{ boxShadow: "none" }}
          >
            {props.pergunta}
          </button>
        </p>
        <div
          id={`resposta_${props.id}`}
          className="accordion-collapse collapse"
          aria-labelledby="headingTwo"
          data-bs-parent={`#${props.parent}`}
        >
          <div className="accordion-body pt-0 ps-1 pe-0 pb-0">
            <div className="d-flex flew-row flex-nowrap col12 align-items-start ms-3">
              <div className="ms-3" style={{ transform: "translate(0px, -2px)" }}>
                <div className="border border-2 border-top-0 border-end-0" style={{ width: "14px", height: "14px" }}></div>
              </div>
              <div
                className="ms-2 fw-light"
                style={{ fontSize: "smaller" }}
                dangerouslySetInnerHTML={{ __html: `${props.resposta.replace("<br/></p>", "</p>")}` }}
              ></div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}
